import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Form, Input, Button, Card, message } from 'antd'
import { UserOutlined, LockOutlined } from '@ant-design/icons'
import { useAuth } from '../context/AuthContext'

function Login() {
  const [loading, setLoading] = useState(false)
  const { login } = useAuth()
  const navigate = useNavigate()

  const onFinish = async (values) => {
    setLoading(true)
    try {
      await login(values)
      message.success('Bienvenida')
      navigate('/dashboard')
    } catch (error) {
      message.error('Usuario o contraseña incorrectos')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="login-page">
      <div className="login-bg-lines" />
      <div className="login-ring login-ring-1" />
      <div className="login-ring login-ring-2" />
      <div className="login-glow" />

      <div className="login-card-wrap">
        <div className="login-card-glow" />
        <Card className="login-card" bodyStyle={{ padding: '40px 34px' }}>
          <div style={{ textAlign: 'center', marginBottom: 30 }}>
            <div className="login-logo-wrap">
              <div className="login-halo" />
              <img src="/logobox.jpg" alt="Espíritu Libre" className="login-logo" />
            </div>
            <div className="login-title">ESPÍRITU LIBRE</div>
            <div className="login-subtitle">Gestión de Gimnasio</div>
          </div>

          <Form name="login" onFinish={onFinish} size="large" className="login-form">
            <Form.Item name="username" rules={[{ required: true, message: 'Ingrese usuario' }]}>
              <Input prefix={<UserOutlined />} placeholder="Usuario" />
            </Form.Item>
            <Form.Item name="password" rules={[{ required: true, message: 'Ingrese contraseña' }]}>
              <Input.Password prefix={<LockOutlined />} placeholder="Contraseña" />
            </Form.Item>
            <Form.Item style={{ marginTop: 8, marginBottom: 0 }}>
              <Button type="primary" htmlType="submit" loading={loading} block>
                Ingresar
              </Button>
            </Form.Item>
          </Form>
        </Card>
      </div>

      <style>{`
        .login-page {
          min-height: 100vh;
          display: flex;
          justify-content: center;
          align-items: center;
          background: #000000;
          position: relative;
          overflow: hidden;
          padding: 16px;
        }

        /* Fondo: líneas diagonales sutiles tipo gimnasio */
        .login-bg-lines {
          position: absolute;
          inset: -60% -30% -60% -30%;
          background:
            repeating-linear-gradient(45deg, transparent 0 42px, rgba(255,255,255,0.028) 42px 43px),
            repeating-linear-gradient(-45deg, transparent 0 42px, rgba(255,255,255,0.024) 42px 43px);
        }

        .login-ring {
          position: absolute;
          border-radius: 50%;
          border: 1px solid rgba(255,255,255,0.055);
        }
        .login-ring-1 { width: 480px; height: 480px; top: -180px; left: -190px; }
        .login-ring-2 { width: 640px; height: 640px; bottom: -280px; right: -240px; }

        .login-glow {
          position: absolute;
          width: 680px;
          height: 680px;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
          background: radial-gradient(circle, rgba(255,255,255,0.045) 0%, transparent 62%);
          pointer-events: none;
        }

        .login-card-wrap {
          position: relative;
          width: 100%;
          max-width: 400px;
          z-index: 2;
        }

        .login-card-glow {
          position: absolute;
          inset: -30px -20px;
          border-radius: 28px;
          background: radial-gradient(closest-side, rgba(255,255,255,0.14) 0%, transparent 70%);
          filter: blur(26px);
          pointer-events: none;
        }

        .login-card {
          background: #0d0d0d !important;
          border: 1px solid rgba(255,255,255,0.12) !important;
          border-radius: 22px !important;
          box-shadow: 0 24px 70px rgba(0,0,0,0.85), 0 0 0 1px rgba(255,255,255,0.03) !important;
          position: relative;
        }

        /* Logo con halo elegante */
        .login-logo-wrap {
          position: relative;
          width: 118px;
          height: 118px;
          margin: 0 auto 22px;
        }
        .login-halo {
          position: absolute;
          inset: -12px;
          border-radius: 50%;
          background: radial-gradient(circle, rgba(255,255,255,0.30) 0%, rgba(255,255,255,0.07) 55%, transparent 72%);
          filter: blur(9px);
        }
        .login-logo {
          position: relative;
          width: 118px;
          height: 118px;
          border-radius: 50%;
          object-fit: cover;
          border: 3px solid #ffffff;
          box-shadow: 0 0 0 1px rgba(255,255,255,0.25), 0 0 34px rgba(255,255,255,0.16), 0 12px 32px rgba(0,0,0,0.65);
        }

        .login-title {
          color: #ffffff;
          font-size: 26px;
          font-weight: 700;
          letter-spacing: 4px;
          line-height: 1.2;
          text-shadow: 0 0 30px rgba(255,255,255,0.25);
        }
        .login-subtitle {
          color: #8a8a8a;
          font-size: 10.5px;
          font-weight: 500;
          letter-spacing: 5px;
          text-transform: uppercase;
          margin-top: 8px;
        }

        /* Campos: oscuros, borde gris fino, foco blanco + resplandor */
        .login-form .ant-input-affix-wrapper {
          background: #0a0a0a !important;
          border: 1px solid #2a2a2a !important;
          border-radius: 12px !important;
          box-shadow: none !important;
          transition: border-color 0.25s ease, box-shadow 0.25s ease;
          padding: 10px 14px;
        }
        .login-form .ant-input-affix-wrapper .ant-input {
          background: transparent !important;
          color: #ffffff;
        }
        .login-form .ant-input-affix-wrapper .ant-input::placeholder {
          color: #5a5a5a;
        }
        .login-form .ant-input-prefix {
          color: rgba(255,255,255,0.75);
          transition: color 0.25s ease;
          margin-right: 10px;
        }
        .login-form .ant-input-affix-wrapper:hover {
          border-color: #4a4a4a !important;
        }
        .login-form .ant-input-affix-wrapper:focus-within,
        .login-form .ant-input-affix-wrapper-focused {
          border-color: #ffffff !important;
          box-shadow: 0 0 0 3px rgba(255,255,255,0.12), 0 0 26px rgba(255,255,255,0.10) !important;
        }
        .login-form .ant-input-affix-wrapper:focus-within .ant-input-prefix,
        .login-form .ant-input-affix-wrapper-focused .ant-input-prefix {
          color: #ffffff;
        }

        /* Botón Ingresar: gradiente, redondeado, sombra y efecto al presionar */
        .login-form .ant-btn-primary {
          height: 48px;
          border-radius: 14px;
          font-weight: 600;
          font-size: 15px;
          letter-spacing: 3px;
          text-transform: uppercase;
          color: #000000;
          border: none;
          background: linear-gradient(180deg, #ffffff 0%, #e4e4e4 50%, #ffffff 100%);
          box-shadow: 0 6px 22px rgba(255,255,255,0.18), 0 0 0 1px rgba(255,255,255,0.45);
          transition: transform 0.12s ease, box-shadow 0.2s ease, filter 0.2s ease;
        }
        .login-form .ant-btn-primary:hover:not(:disabled) {
          box-shadow: 0 8px 30px rgba(255,255,255,0.30), 0 0 0 1px rgba(255,255,255,0.6);
          filter: brightness(1.03);
        }
        .login-form .ant-btn-primary:active:not(:disabled) {
          transform: scale(0.98);
          box-shadow: 0 3px 10px rgba(255,255,255,0.16);
        }
        .login-form .ant-btn-primary[disabled] {
          background: #222222 !important;
          color: #666666 !important;
        }
      `}</style>
    </div>
  )
}

export default Login
